<template>
    <Detalhes :titulo="'Dano ou Avaria'" 
        @aoSalvar="salvarAvarias" 
        @aoSair="sairDetalhesAvarias" 
        :exibirLoader="exibirLoader" 
        :labelIndicacao="'Clique nas imagens e desenhe as avarias nos croquis'"
        :labelBotaoSalvar="labelBotaoSalvar"
    >
        <div class="flex items-center text-azul-info justify-center mt-2">
            <Icone :nome="'touch_app'" /> <span> Clique nas imagens e desenhe as avarias nos croquis</span>
        </div>
        <div class="flex flex-col justify-center items-center mb-4 landscape:flex-row">
            <MarcacaoImagem 
                :imagem="croquisAvarias[0].imagem"
                :idImagemOrigem="'avaria-origem-frente'"
                :refComponente="'avariaMarcacaoFrente'"
                @ultimaImagem="tratarUltimaImagem"
            />
            <MarcacaoImagem 
                :imagem="croquisAvarias[1].imagem"
                :idImagemOrigem="'avaria-origem-verso'"
                :refComponente="'avariaMarcacaoVerso'"
                @ultimaImagem="tratarUltimaImagem"
            />
        </div>
    </Detalhes>
</template>

<script>
import { defineComponent } from 'vue';
import Actions from '@/store/Actions'
import Detalhes from '@/components/Detalhes.vue';
import ComponenteAvariaService from '@/services/componentes/ComponenteAvariaService';
import FuncoesHelper from '@/helpers/FuncoesHelper';
import ComponentesService from '@/services/ComponentesService';
import MarcacaoImagem from '@/components/MarcacaoImagem.vue';
import Icone from '@/components/Icone.vue';

export default defineComponent({
    name: 'DetalheAvaria',
    components: {
        Detalhes,
        MarcacaoImagem,
        Icone
    },
    methods: {
        tratarUltimaImagem(dados) {
            if (dados.ultimaMarcacao.markers.length > 0) {
                this.estadoUltimaMarcacao[dados.refComponente] = {
                    ultimaMarcacao: dados.ultimaMarcacao,
                    dataUrl: dados.dataUrl
                };
            } else {
                delete this.estadoUltimaMarcacao[dados.refComponente];
            }
            
            this.labelBotaoSalvar = Object.keys(this.estadoUltimaMarcacao).length == 0 ? 'Salvar sem avaria' : 'Salvar';
        },
        sairDetalhesAvarias() {
            this.$router.push(`/${this.identificador}/${this.localRealizacao}/${this.modulo}/etapa/${this.etapaAtual}`)
        },
        salvarAvarias() {
            this.exibirLoader = true
            let respostaAvarias = {};

            this.croquisAvarias.forEach(avaria => {
                const refComponente = `avariaMarcacao${avaria.nome.charAt(0).toUpperCase() + avaria.nome.slice(1)}`;
                let dataURL = '';
                if (Object.prototype.hasOwnProperty.call(this.estadoUltimaMarcacao, refComponente) && this.estadoUltimaMarcacao[refComponente].dataUrl) {
                    dataURL = this.estadoUltimaMarcacao[refComponente].dataUrl;
                } else {
                    const imagem = document.getElementById(`avaria-origem-${avaria.nome}`);
                    const canvas = document.createElement("canvas");
                    const context = canvas.getContext('2d');

                    canvas.width = imagem.width;
                    canvas.height = imagem.height;
                    
                    context.drawImage(imagem, 0, 0, canvas.width, canvas.height);
                    dataURL = canvas.toDataURL();
                }                

                respostaAvarias = {
                    ...respostaAvarias,
                    [FuncoesHelper.gerarUuid()]: {
                        label: avaria.nome,
                        tipo: 'Avaria',
                        imagem: dataURL,
                        etapa: this.etapaAtual,
                        descricao: this.tipoVeiculoSelecionado,
                        idComponente: this.idComponente,
                        semAvaria: Object.keys(this.estadoUltimaMarcacao).length == 0
                    }
                }
            });

            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaAtual, this.idComponente, respostaAvarias)
            this.$store.dispatch(Actions.SALVAR_AVARIAS,
                {
                    localRealizacao: this.localRealizacao,
                    modulo: this.modulo,
                    etapa: this.etapaAtual,
                    idComponente: this.idComponente,
                    avarias: respostaAvarias
                }
            );
        }
    },
    setup() {
        return ComponenteAvariaService.detalheAvariaSetup()
    }
});
</script>